import 'isomorphic-fetch';
// import { createHttpLink } from 'apollo-link-http';
import { BatchHttpLink } from 'apollo-link-batch-http';

// const httpLink = createHttpLink({
//   uri: process.env.GRAPHQL,
//   fetch,
// });

const httpLink = new BatchHttpLink({
  uri: process.env.GRAPHQL,
  fetch,
});

export default httpLink;



// WEBPACK FOOTER //
// ./src/data/links/httpLink.js